import { FC } from 'react';
import AlertDialog from 'components/AlertDialog';
import Typography from '@mui/material/Typography';
import { Disclosure } from 'further-ui/hooks';

type Props = {
  disclosure: Disclosure;
  onConfirm: (params: { recalculateFees: boolean }) => void;
};

const TrancheChangeWarningModal: FC<Props> = ({ disclosure, onConfirm }) => (
  <AlertDialog
    open={disclosure.isOpen}
    title="Update fees for this subscription?"
    content={
      <Typography>
        You are editing this subscription's tranche. Should the system calculate
        fees based on the new tranche's default fee template or leave current
        fees unchanged?
      </Typography>
    }
    size="sm"
    onConfirm={() => onConfirm({ recalculateFees: true })}
    onAlternateConfirm={() => onConfirm({ recalculateFees: false })}
    onClose={disclosure.onClose}
    btnLabels={{
      confirm: 'Use new tranche fees',
      alternateConfirm: 'Leave fees unchanged',
      cancel: 'Cancel',
    }}
    cancelBtnProps={{
      color: 'secondary',
    }}
  />
);

export default TrancheChangeWarningModal;
